var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddToHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iOS - Share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "23,10.5 19,10.5 18.5,10.5 18.5,11.5 19,11.5 22.5,11.5 22.5,26.5 7.5,26.5 7.5,11.5 11,11.5 11.5,11.5 11.5,10.5    11,10.5 7,10.5 6.5,10.5 6.5,11 6.5,27 6.5,27.5 7,27.5 23,27.5 23.5,27.5 23.5,27 23.5,11 23.5,10.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.4,8.4 14.5,5.2 14.5,19 14.5,19.5 15.5,19.5 15.5,19 15.5,5.2 18.6,8.4 19,8.7 19.7,8 19.4,7.6 15.4,3.6    15,3.3 14.6,3.6 10.6,7.6 10.3,8 11,8.7  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToHome);
export default __webpack_public_path__ + "static/media/add-to-home.5e8be729.svg";
export { ForwardRef as ReactComponent };